module.exports = __webpack_public_path__ + "assets/img/20_966_big.dce0eff3.jpg";